import basicData from "./basicData";

const basicDataService = [
    {
        matcher: 'basicData',
        reply: config => {
            return [200, basicData];
        }
    },
]

export default basicDataService;